"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = exports.ModalContent = exports.ModalHeader = exports.Modal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var BootstrapHelper_1 = require("../../BootstrapHelper");
var Panel_1 = require("../Panel");
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.close = function (ev) {
            _this.props.onClose();
        };
        return _this;
    }
    Modal.prototype.render = function () {
        var _this = this;
        var clz = this.props.className;
        var bem = (0, BootstrapHelper_1.B)().bl("modal");
        var clas = bem.pmod(this.props.position).bem;
        var clsWrapper = bem
            .el("wrapper")
            .pmod(this.props.wrapHeight + "-height")
            .pmod(this.props.overflow ? "overflow-".concat(this.props.overflow) : "")
            .pmod(this.props.wrapWidth + "-width")
            .pmod("spacing-" + this.props.spacing).bem;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(clz, " ").concat(clas) }, { children: [!this.props.disableBackdrop && ((0, jsx_runtime_1.jsx)("div", { className: "".concat(bem.el("backdrop").bem, " animated fadeIn speed-3"), onClick: this.close, id: "ModalBackdrop", ref: function (e) { return (_this.backdropEl = e); } })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(clsWrapper, " ").concat(this.props.wrapperAnimationClassName), ref: function (e) { return (_this.contentWrapperEl = e); } }, { children: (0, jsx_runtime_1.jsx)(Panel_1.Panel, __assign({}, this.props.panelProps, { className: "".concat((this.props.panelProps && this.props.panelProps.className) || "", " ").concat(bem.el("wrapper-content").bem) }, { children: this.props.children })) }))] })));
    };
    Modal.defaultProps = {
        className: "",
        position: "middle",
        close: function () { },
        spacing: "none",
        wrapHeight: "default",
        wrapWidth: "default",
        disableBackdrop: false,
        wrapperAnimationClassName: "fadeIn"
    };
    return Modal;
}(React.Component));
exports.Modal = Modal;
var ModalHeader = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, props, { className: "modal__block modal__block--header container-fluid ".concat(props.className || "") }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "col" }, { children: props.children })) })) })));
};
exports.ModalHeader = ModalHeader;
var ModalFooter = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, props, { className: "modal__block modal__block--footer ".concat(props.className || "") }, { children: props.children })));
};
exports.ModalFooter = ModalFooter;
var ModalContent = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, props, { className: "modal__block modal__block--content ".concat(props.className || "") }, { children: props.children })));
};
exports.ModalContent = ModalContent;
